import {HighlightAttributes} from "./HighlightAttributes";
import {jsonapi} from "../../../core/models/JSONAPI";

export class Highlight implements jsonapi<HighlightAttributes> {

  constructor(public type: string, public id: string, public attributes: HighlightAttributes) {

  }
}
